import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canAccessBulkApprovalFromLocalStorage } from './utils/bulk-approval-access';
import { isTruthyRoleFlag } from './utils/bulk-upload-access';

export const bulkApprovalGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const roleDetailRaw = localStorage.getItem('role_detail');
  let roleDetail: any = null;
  try {
    roleDetail = roleDetailRaw ? JSON.parse(roleDetailRaw) : null;
  } catch {
    roleDetail = null;
  }

  const flagAllowed = isTruthyRoleFlag(roleDetail?.is_bulk_approval_history_visible);
  const anyFlagPresent = roleDetail?.is_bulk_approval_history_visible != null;

  const allowed = anyFlagPresent ? flagAllowed : canAccessBulkApprovalFromLocalStorage();
  if (allowed) return true;
  return router.createUrlTree(['/products']);
};
